import React from "react";
import Routes from "./Routes";
import { LoadScript } from "@react-google-maps/api";

function App() {
  const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
  return (
    <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY} libraries={["places"]}>
      <Routes />
    </LoadScript>
  );
}

export default App;